import { createRequestId, postEmailRequest } from './emailApi'

const contactEmailEndpoint = process.env.REACT_APP_CONTACT_EMAIL_ENDPOINT || '/api/send-contact-email.php'

export async function sendContactEmails(formData) {
    return postEmailRequest(
        contactEmailEndpoint,
        { ...formData, requestId: createRequestId() },
        'Contact email service'
    )
}
